export default __webpack_public_path__ + "static/media/style4.d9cb449b.svg";